import React from "react";

import { ApiIndents } from "apihandlers/indent";
import {
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Typography,
  StepButton,
  IconButton,
} from "@mui/material";

import { Close as CloseIcon } from "@mui/icons-material";

import AutoComplete from "components/Custom/AutoComplete";
import Btn from "components/Custom/Btn";
import TxtBox from "components/Custom/TxtBox";
import { LABELS } from "common/labels";
import { DateFunctions } from "common/datefunctions";

const API_HANDLER_INDENT = new ApiIndents();

const TripDeliveries = (props: any) => {
  const {
    showTrips,
    tripDelivery,
    trips,
    tripsRef,
    setDetails,
    setShowMarkers,
    setShowAreas,
    setShowTrips,
    vehiclesList,
    vehiclesRef,
    setTripDelivery,
    onLocationUpdate,
    drivers,
    driverRef,
  } = props;

  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState<{
    [k: number]: boolean;
  }>({});

  const getTripDeliveries = () => {
    setTripDelivery([]);
    setShowAreas(false);
    const indentId = tripsRef.current.selectedValue.id;
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    const userId = driverRef.current.selectedValue.id;
    const vehicleId = vehiclesRef.current.selectedValue.id;
    const args = {
      indentId,
      fromDt,
      toDt,
      userId,
      vehicleId,
    };
    API_HANDLER_INDENT.getLoadingPtComments(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        const deliveries = response.records.map((delivery, i) => {
          return {
            ...delivery,
            lat: Number(delivery.latitude),
            lng: Number(delivery.longitude),
          };
        });
        for (let i = 0; i < deliveries.length; i++) {
          //if vertices is given then polygon will show and even if lat,lng and vertices both present then vertices will be considered is given
          if (deliveries[i].vertices) {
            let vertices = JSON.parse(deliveries[i].vertices).map((point) => {
              point[0] = Number(point[0]);
              point[1] = Number(point[1]);
              return point;
            });
            deliveries[i].vertices = vertices;
          }
          // no comments written, explain the logic
          //if lat lng is given then this condition will run
          else if (
            !isNaN(deliveries.lat) &&
            !isNaN(deliveries.lng) &&
            deliveries.lat !== null &&
            deliveries.lng !== null
          ) {
          } else {
            deliveries[i].vertices = [];
          }
        }

        setDetails(true);
        setTripDelivery(deliveries);
      }
    });
  };

  //stepper on click
  const handleStep = (step: number, detail: any) => () => {
    setActiveStep(step);
    onLocationUpdate(detail);
  };

  const getTripsData = () => {
    setShowTrips(false);
    setShowTrips(!showTrips);
    setDetails(false);
    setTripDelivery(null);
    setShowMarkers(true);
    setShowAreas(true);
  };
  return (
    <>
      {showTrips && (
        <div className="tripsDelivery">
          <div className="transferHead">
            <div>
              <h4 className="transferCustomer">{LABELS.TRIP_DELIVERIES}</h4>
            </div>
            <div>
              <IconButton
                aria-label="close"
                onClick={getTripsData}
                style={{ marginRight: "0.5rem" }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
          <div className="tripDataEntry">
            <div className=" flexRowJustify">
              <div className="formGroup width45">
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.FROM_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="fromDt"
                  defaultValue={DateFunctions.getDate(
                    "today",
                    "from",
                    "YYYY-MM-DD"
                  )}
                />
              </div>
              <div className="formGroup width45">
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.TO_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="toDt"
                  defaultValue={DateFunctions.getDate(
                    "thismonth",
                    "to",
                    "YYYY-MM-DD"
                  )}
                />
              </div>
            </div>
            <div className="formGroup ">
              <label
                style={{
                  fontWeight: "500",
                  fontSize: 14,
                  marginTop: 6,
                  marginRight: 8,
                }}
              >
                {LABELS.SELECT_TRIP}
              </label>
              <AutoComplete
                list={trips}
                childRef={tripsRef}
                placeholder={LABELS.SELECT_TRIP}
              />
            </div>

            <div className="formGroup ">
              <label
                style={{
                  fontWeight: "500",
                  fontSize: 14,
                  marginTop: 6,
                  marginRight: 8,
                }}
              >
                {LABELS.VEHICLE_NO}
              </label>
              <AutoComplete
                list={vehiclesList}
                childRef={vehiclesRef}
                placeholder={LABELS.SELECT_VEHICLES}
              />
            </div>
            <div className="formGroup ">
              <label
                style={{
                  fontWeight: "500",
                  fontSize: 14,
                  marginTop: 6,
                  marginRight: 8,
                }}
              >
                {LABELS.DRIVER_NAME}
              </label>
              <AutoComplete
                list={drivers}
                childRef={driverRef}
                placeholder={LABELS.SELECT_DRIVER}
              />
            </div>
            <div className="flexRowJustify">
              <div></div>
              <Btn
                paddingLeft={10}
                paddingRight={10}
                text={LABELS.LOAD_DATA}
                onClick={getTripDeliveries}
              />
              <div></div>
            </div>
          </div>
          <div className="stepperStyle">
            {tripDelivery && (
              <>
                <h4 style={{ textAlign: "center" }}>{LABELS.TRIP_STATUS}</h4>
                {/* <div className="stepper"> */}
                <Stepper
                  nonLinear
                  orientation="vertical"
                  activeStep={activeStep}
                >
                  {tripDelivery.map((detail, index) => (
                    <Step
                      key={detail.enteredOn + index}
                      completed={completed[index]}
                    >
                      <StepButton
                        color="inherit"
                        onClick={handleStep(index, detail)}
                      >
                        <StepLabel>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div>{detail.areaName}</div>
                          </div>
                          <div>{detail.enteredOn}</div>
                          {detail.deliveryComments}
                        </StepLabel>
                      </StepButton>
                    </Step>
                  ))}
                </Stepper>
                {/* </div> */}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default TripDeliveries;
